<template>
    <div class="service-hours">
        <div class="main-container-work-settings">
            <div class="heading-container">
                <!--Title-->
                <h3>{{ $t("schedule.serviceHours") }}</h3>

                <!--Team select-->
                <div v-if="
                    adminDetails.group_owner == 1 &&
                    adminDetails.group_active == 1

                " class="select-input-wrap">
                    <label class="stylist-label" for="stylist-select"
                        :class="generalOptions.app_id === 5 ? 'loctician' : ''">Select
                        {{
                            generalOptions.app_id === 1
                                ? "Stylist"
                                : generalOptions.app_id === 2
                                    ? "Barber"
                                    : generalOptions.app_id === 5
                                        ? "Loctician"
                                        : ""
                        }}</label>
                    <select id="stylist-select" v-model="for_stylist_id" v-on:change="onStylistChange"
                        class="selectInput selectInputSmall">
                        <option v-for="(member, index) in groupMembers" v-bind:key="index" v-bind:value="member.user.id"
                            v-bind:disabled="member.active != 1">
                            {{ member.user.first_name }} {{ member.user.last_name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <!--Service Hours section-->
        <div v-if="!loadingServiceHours" class="main-container-work-settings add-margin-top">
            <div class="content-work-settings">
                <div class="work-settings-wrap">
                    <div class="row-section-wrap section-wrap">
                        <span class="section-headline-work">{{ $t("schedule.noteClients") }}</span>
                        <div class="heading-text-wrap">
                            <label for="notes-for-clients" class="text-for-clients">{{
                                $t("schedule.shortNoteClients") }}
                                <a class="main-text-link" target="_blank" :href="portfolio_url">{{
                                    $t("schedule.yourPortfolioPage")
                                    }}</a>{{ $t("schedule.underWorkingHoursSection") }}</label>
                            <textarea id="notes-for-clients" maxlength="150" v-model="work_settings.notes_for_clients"
                                class="text-field" placeholder="Write a short note for your clients"></textarea>
                        </div>
                        <div class="btn-wrapper">
                            <div>
                                <button class="primary-btn extra-small" v-on:click="saveWorkSettings">
                                    {{ $t("general.save") }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row-section-wrap section-wrap">
                        <div class="row-section-inner-wrap">
                            <span class="section-headline-work">{{ $t("schedule.workDays") }}</span>
                            <div class="row-section-week highlighted-box section-wrap" v-for="(day, index) in weekDays"
                                v-bind:key="index">
                                <div class="">
                                    <span class="day-label">{{ $t("days." + day) }}</span>
                                </div>
                                <div class="section-wrap day-wrapper">
                                    <!--Active-->
                                    <div class="switch-wrap">
                                        <label :for="'active-day' + index">{{ $t("general.active") }}:</label>
                                        <div>
                                            <label class="switch">
                                                <input :id="'active-day' + index" type="checkbox" :disabled="loading"
                                                    v-model="work_settings[day]" @change="saveWorkSettings" />
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <!--Scheduled from - to-->
                                    <div v-if="work_settings[day]" class="day-settings-row">
                                        <div class="hours-wrap">
                                            <div>{{ $t("schedule.from") }}:</div>
                                            <div>
                                                <TimePicker format="hh:mm A" v-model="work_hours[day + '_from']"
                                                    @update:modelValue="handleTimeSave($event, day, 'from')" />
                                            </div>
                                        </div>
                                        <div class="hours-wrap">
                                            <div>To:</div>
                                            <div>
                                                <TimePicker format="hh:mm A" v-model="work_hours[day + '_to']"
                                                    @update:modelValue="handleTimeSave($event, day, 'to')" />
                                            </div>
                                        </div>
                                    </div>
                                    <!--Blocked from - to-->
                                    <div v-if="work_settings[day]" class="day-settings-row blocked-row">
                                        <div class="hours-wrap">
                                            <div>{{ $t("schedule.blockFrom") }}:</div>
                                            <div>
                                                <TimePicker format="hh:mm A" v-model="work_hours[day + '_block_from']"
                                                    @update:modelValue="handleTimeSave($event, day, 'block_from')" />
                                            </div>
                                        </div>
                                        <div class="hours-wrap">
                                            <div>{{ $t("schedule.blockTo") }}:</div>
                                            <div>
                                                <TimePicker format="hh:mm A" v-model="work_hours[day + '_block_to']"
                                                    @update:modelValue="handleTimeSave($event, day, 'block_to')" />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Walks-Ins-Only-->
                                    <div class="walk-in-container" v-if="work_settings[day]">
                                        <div class="walk-checkbox">
                                            <label class="switch">
                                                <input :id="'walks-ins-checked' + index" type="checkbox"
                                                    v-model="work_settings[day + '_walkin']" true-value="1"
                                                    false-value="0" @change="saveWorkSettings" />
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                        <div class="walks-content walk-label">
                                            <label :for="'walks-ins-checked' + index">Walk-Ins Only</label>
                                        </div>

                                        <div class="walks-content walk-info">
                                            <span><i class="fa fa-info-circle" v-tooltip="walksInsInfo"></i></span>
                                        </div>
                                    </div>

                                    <!--Exeptions-->
                                    <div v-if="!work_settings[day]" class="exeptions-row">
                                        <div class="exeptions-btn-wrap">
                                            <div>
                                                <button :disabled="work_settings[day] != work_settings_clone[day]"
                                                    v-on:click="openModal(day)" type="button"
                                                    class="primary-btn extra-small" :class="{
                                                        'disabled-button':
                                                            work_settings[day] != work_settings_clone[day],
                                                    }">
                                                    {{ $t("schedule.exceptions") }}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="datepicker-main-wrapper">
                                            <div v-if="exceptions[day].openDateModal" class="datepicker-wrapper">
                                                <VueDatePicker :inline="true" :time-config="{ enableTimePicker: false }"
                                                    :formats="{ preview: 'yyyy-MM-dd' }" :auto-apply="true"
                                                    :highlight="{ dates: exceptions[day].highlighted }"
                                                    :disabledDates="disableDates(day)"
                                                    @update:model-value="onDateClickFromDatePicker($event, day)" />
                                            </div>
                                        </div>
                                        <div class="exeptions-day-wrapper section-wrap"
                                            v-if="exceptions[day].dates.length != 0">
                                            <div v-for="(date, key) in exceptions[day].dates" v-bind:key="key"
                                                class="section-wrap">
                                                <div class="exception-day">
                                                    {{ date.dateF }}
                                                    <span @click="delete_exception_day(date.id)" class="button-edit"><i
                                                            aria-hidden="true" class="fa fa-times"></i></span>
                                                    <i @click="openTimeModal(date)" aria-hidden="true"
                                                        class="fa fa-clock-o"></i>
                                                </div>
                                                <a class="exeption-link" @click="openTimeModal(date)">{{ date.work_from
                                                    }} - <br />{{ date.work_to }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MainLoader v-if="loadingServiceHours" class="section-wrap" />
        <!--Change Exeption Hour Modal-->
        <div class="modal" tabindex="-1" role="dialog" id="time-modal">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="title">
                            <h5>{{ $t("schedule.changeHours") }}</h5>
                        </div>
                        <button type="button" @click="closeTimeModal" class="close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="modal-hour-input-wrap">
                            <div class="timepicker-wrap">
                                <label>From</label>
                                <TimePicker format="hh:mm A" v-if="timeObj.work_from" v-model="timeObj.work_from" />
                            </div>
                            <div class="timepicker-wrap">
                                <label>To</label>
                                <TimePicker format="hh:mm A" v-if="timeObj.work_to" v-model="timeObj.work_to" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-save">
                            <div>
                                <button @click="changeTime()" type="button" class="primary-btn extra-small">
                                    {{ $t("schedule.saveChanges") }}
                                </button>
                            </div>
                            <div>
                                <button type="button" @click="closeTimeModal" class="secondary-btn small"
                                    data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from "./../../services/auth.js";
import api from "../../services/apiEndpoints.js";
import messages from "./../../services/messages.js";
import TimePicker from 'vue3-timepicker';
import 'vue3-timepicker/dist/VueTimepicker.css';
import moment from "moment";
import eventBus from "../../services/eventBus.js";

import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css"; // import the CSS

import { Modal } from "bootstrap";
import MainLoader from '../admin/general-components/MainLoader.vue';

export default {
    name: "ServiceHours",

    data: function () {
        return {
            user: null,
            walksInsInfo: "It means that your shop is open but only accept Walk-Ins(no online appointments).",
            work_settings: {},
            work_settings_clone: {},
            work_hours: {
                sunday_from: {},
                sunday_to: {},
                sunday_block_from: {},
                sunday_block_to: {},
                monday_from: {},
                monday_to: {},
                monday_block_from: {},
                monday_block_to: {},
                tuesday_from: {},
                tuesday_to: {},
                tuesday_block_from: {},
                tuesday_block_to: {},
                wednesday_from: {},
                wednesday_to: {},
                wednesday_block_from: {},
                wednesday_block_to: {},
                thursday_from: {},
                thursday_to: {},
                thursday_block_from: {},
                thursday_block_to: {},
                friday_from: {},
                friday_to: {},
                friday_block_from: {},
                friday_block_to: {},
                saturday_from: {},
                saturday_to: {},
                saturday_block_from: {},
                saturday_block_to: {},
            },
            weekDays: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
            for_stylist_id: 0,
            settings: {},
            notification_settings: {},
            portfolio_url: "",
            timeSlotBooking: "",
            problemsInHours: false,
            timeObj: {
                work_from: false,
                date: "",
                work_to: false,
            },
            exceptions: {
                monday: { dates: [], openDateModal: false, highlighted: [] },
                tuesday: { dates: [], openDateModal: false, highlighted: [] },
                wednesday: { dates: [], openDateModal: false, highlighted: [] },
                thursday: { dates: [], openDateModal: false, highlighted: [] },
                friday: { dates: [], openDateModal: false, highlighted: [] },
                saturday: { dates: [], openDateModal: false, highlighted: [] },
                sunday: { dates: [], openDateModal: false, highlighted: [] },
            },
            loading: false,
            initializing: true,
            loadingServiceHours: false,
        };
    },
    mounted: function () {
        this.user = auth.state.user;
        this.for_stylist_id = auth.state.user.id;
        this.getWorkSettings();

        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (this.$store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });
    },
    beforeUnmount() {
        eventBus.off("admin_details_loaded");
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
        groupMembers: {
            get: function () {
                return this.$store.state.stylists;
            },
            set: function (value) {
                this.$store.commit("setStylists", value);
            },
        },
    },
    methods: {
        isSectionVisible(section) {
            if (!this.sections) {
                return true;
            }

            if (this.sections.indexOf(section) != -1) {
                return true;
            }

            return false;
        },
        onAdminDetailsLoad: function () {
            if (this.adminDetails.group_id && this.adminDetails.group_owner) {
                this.getGroupsMembers(this.adminDetails.group_id);
            }
        },
        getGroupsMembers: function (group_id) {
            this.serviceCategories = [];
            this.services = {};

            this.$http.get(api.actions.get_stylist_group_members + group_id).then(
                function (response) {
                    if (typeof response.data.members != "undefined") {
                        this.groupMembers = response.data.members;
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },

        getWorkSettings() {
            this.loadingServiceHours = true;

            let stylist_id =
                this.for_stylist_id != auth.state.user.id
                    ? "?user_id=" + this.for_stylist_id
                    : "";

            let getAllSettings = stylist_id ? "&getAllSettings=1" : "?getAllSettings=1";

            this.$http
                .get(api.actions.get_work_settings + stylist_id + getAllSettings)
                .then(response => {
                    if (!response.data.work_settings) return;

                    this.work_settings = response.data.work_settings;
                    this.work_settings_clone = { ...this.work_settings };

                    this.weekDays.forEach(day => {
                        this.work_settings[day] = !!this.work_settings[day];
                    });

                    this.work_settings.accept_new_clients = !!this.work_settings.accept_new_clients;
                    this.work_settings.prevent_clients_book = !!this.work_settings.prevent_clients_book;
                    this.work_settings.prevent_clients_reschedule = !!this.work_settings.prevent_clients_reschedule;

                    this.settings = response.data.settings;
                    this.settings.auto_confirm_appointments = !!this.settings.auto_confirm_appointments;
                    this.settings.accept_website_booking = !!this.settings.accept_website_booking;

                    this.notification_settings = response.data.notification_settings;
                    this.notification_settings.invite = !!this.notification_settings.invite;

                    this.portfolio_url = response.data.portfolio_url;
                    this.timeSlotBooking = response.data.settings.default_slot_time;

                    this.processHours();
                    this.getExceptions();

                    this.$nextTick(() => {
                        this.initializing = false;
                    });
                })
                .catch(error => {
                    console.error("Failed to load work settings:", error);
                })
                .finally(() => {
                    this.loadingServiceHours = false;
                });
        },
        saveWorkSettings() {
            this.getHours();
            if (this.problemsInHours) return;

            this.loading = true;

            // IMPORTANT: clone state (DO NOT mutate reactive object)
            const payload = { ...this.work_settings };

            // Convert weekdays to 0 / 1 ONLY in payload
            this.weekDays.forEach(day => {
                payload[day] = payload[day] ? 1 : 0;
            });

            // Convert booleans for backend
            payload.accept_new_clients = payload.accept_new_clients ? 1 : 0;
            payload.prevent_clients_book = payload.prevent_clients_book ? 1 : 0;
            payload.prevent_clients_reschedule = payload.prevent_clients_reschedule ? 1 : 0;

            payload.accept_website_booking = this.settings.accept_website_booking ? 1 : 0;
            payload.default_slot_time = this.timeSlotBooking;
            payload.auto_confirm_appointments = this.settings.auto_confirm_appointments ? 1 : 0;

            payload.notification_invite = this.notification_settings.invite ? 1 : 0;
            payload.notification_schedule = this.notification_settings.schedule;
            payload.notification_reschedule = this.notification_settings.reschedule;
            payload.notification_cancel = this.notification_settings.cancel;

            if (this.for_stylist_id != auth.state.user.id) {
                payload.group_user_id = this.for_stylist_id;
            }

            this.$http
                .post(api.actions.save_work_settings, payload)
                .then(response => {
                    this.loading = false;

                    if (response.data.error === false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        processHours: function () {
            let self = this;
            this.weekDays.forEach(function (day) {
                self.work_hours[day + "_from"] = self.processHourFormat(self.work_settings[day + "_from"]);
                self.work_hours[day + "_to"] = self.processHourFormat(self.work_settings[day + "_to"]);
                self.work_hours[day + "_block_from"] = self.processHourFormat(self.work_settings[day + "_block_from"]);
                self.work_hours[day + "_block_to"] = self.processHourFormat(self.work_settings[day + "_block_to"]);
            });
        },
        processHourFormat: function (value) {
            if (!value) {
                return {
                    hh: "",
                    mm: "",
                    A: "AM",
                };
            }

            let obj = moment(value, ["hh:mh A"]);
            let hour = {
                hh: obj.format("hh"),
                mm: obj.format("mm"),
                A: obj.format("A"),
            };

            return hour;
        },
        getDateFromTimeToCompare: function (timeString) {
            if (typeof timeString == "undefined" || timeString == "") {
                return;
            }
            //timeString should be in hh:mm A format
            return moment(moment().format("YYYY-MM-DD") + " " + timeString, "YYYY-MM-DD hh:mm A").toDate();
        },
        getHours: function () {

            // RESET ERROR STATE
            this.problemsInHours = false;

            let self = this;

            this.weekDays.forEach(function (day) {

                if (self.problemsInHours) return;

                let dayFrom = self.getProcessedHour(self.work_hours[day + "_from"]);
                let dayTo = self.getProcessedHour(self.work_hours[day + "_to"]);
                let dayBlockFrom = self.getProcessedHour(self.work_hours[day + "_block_from"]);
                let dayBlockTo = self.getProcessedHour(self.work_hours[day + "_block_to"]);

                if (!self.work_settings[day]) return;

                let dayFromDate = self.getDateFromTimeToCompare(dayFrom);
                let dayToDate = self.getDateFromTimeToCompare(dayTo);

                if (dayFromDate && dayToDate && dayFromDate >= dayToDate) {
                    self.problemsInHours = true;
                    messages.errorMessage("From Schedule Time needs to be lesser than To Schedule Time");
                    return;
                }

                if ((dayFromDate && !dayToDate) || (!dayFromDate && dayToDate)) {
                    self.problemsInHours = true;
                    messages.errorMessage("From Schedule Time and To Schedule Time needs to be set together");
                    return;
                }

                let dayBlockFromDate = self.getDateFromTimeToCompare(dayBlockFrom);
                let dayBlockToDate = self.getDateFromTimeToCompare(dayBlockTo);

                if (dayBlockFromDate && dayBlockToDate && dayBlockFromDate >= dayBlockToDate) {
                    self.problemsInHours = true;
                    messages.errorMessage("From Block Time needs to be lesser than To Block Time");
                    return;
                }

                if ((dayBlockFromDate && !dayBlockToDate) || (!dayBlockFromDate && dayBlockToDate)) {
                    self.problemsInHours = true;
                    messages.errorMessage("From Block Time and To Block Time needs to be set together");
                    return;
                }

                self.work_settings[day + "_from"] = dayFrom;
                self.work_settings[day + "_to"] = dayTo;
                self.work_settings[day + "_block_from"] = dayBlockFrom;
                self.work_settings[day + "_block_to"] = dayBlockTo;

            });
        },
        getProcessedHour: function (value) {
            if (value["hh"] === "" || value["mm"] === "" || value["A"] === "") {
                return "";
            }

            return value["hh"] + ":" + value["mm"] + " " + value["A"];
        },
        onStylistChange() {
            this.getWorkSettings();
        },
        openModal(day) {
            for (let i in this.exceptions) {
                if (i === day) {
                    continue;
                }
                this.exceptions[i].openDateModal = false;
            }
            this.exceptions[day].openDateModal = !this.exceptions[day].openDateModal;
        },
        onDateClickFromDatePicker: function (date, day) {
            this.exceptions[day].openDateModal = false;

            let data = {};
            data.dates = {
                0: {
                    work_from: "",
                    date: moment(date).format("YYYY-MM-DD"),
                    work_to: "",
                },
            };
            if (this.for_stylist_id != auth.state.user.id) {
                data.group_user_id = this.for_stylist_id;
            }
            this.$http.post(api.actions.save_exception_days, data).then(
                function (response) {
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                        this.getExceptions();
                    }
                }.bind(this)
            );
        },

        getExceptions() {
            let user_id = this.for_stylist_id != auth.state.user.id ? this.for_stylist_id : auth.state.user.id;

            this.exceptions = {
                monday: { dates: [], openDateModal: false, highlighted: [] },
                tuesday: { dates: [], openDateModal: false, highlighted: [] },
                wednesday: { dates: [], openDateModal: false, highlighted: [] },
                thursday: { dates: [], openDateModal: false, highlighted: [] },
                friday: { dates: [], openDateModal: false, highlighted: [] },
                saturday: { dates: [], openDateModal: false, highlighted: [] },
                sunday: { dates: [], openDateModal: false, highlighted: [] },
            };

            this.$http.get(api.actions.get_exceptions_day + "?user_id=" + user_id).then(
                function (response) {
                    let days = response.data.days;
                    //eslint-disable-next-line
                    for (const [key, day] of Object.entries(days)) {
                        let d = moment.utc(day.date).format("DD");
                        let m = moment.utc(day.date).format("M") - 1;
                        let y = moment.utc(day.date).format("YYYY");

                        let fullDate = new Date(Date.UTC(y, m, d));
                        let deleteDate = moment(day.date).format("MMM DD");
                        switch (moment(day.date).weekday()) {
                            case 0:
                                this.exceptions.sunday.dates.push({
                                    date: fullDate,
                                    dateF: deleteDate,
                                    id: day.id,
                                    work_from: day.work_from,
                                    work_to: day.work_to,
                                });
                                this.exceptions.sunday.highlighted.push(fullDate);
                                break;
                            case 1:
                                this.exceptions.monday.dates.push({
                                    date: fullDate,
                                    dateF: deleteDate,
                                    id: day.id,
                                    work_from: day.work_from,
                                    work_to: day.work_to,
                                });
                                this.exceptions.monday.highlighted.push(fullDate);
                                break;
                            case 2:
                                this.exceptions.tuesday.dates.push({
                                    date: fullDate,
                                    dateF: deleteDate,
                                    id: day.id,
                                    work_from: day.work_from,
                                    work_to: day.work_to,
                                });
                                this.exceptions.tuesday.highlighted.push(fullDate);
                                break;
                            case 3:
                                this.exceptions.wednesday.dates.push({
                                    date: fullDate,
                                    dateF: deleteDate,
                                    id: day.id,
                                    work_from: day.work_from,
                                    work_to: day.work_to,
                                });
                                this.exceptions.wednesday.highlighted.push(fullDate);
                                break;
                            case 4:
                                this.exceptions.thursday.dates.push({
                                    date: fullDate,
                                    dateF: deleteDate,
                                    id: day.id,
                                    work_from: day.work_from,
                                    work_to: day.work_to,
                                });
                                this.exceptions.thursday.highlighted.push(fullDate);
                                break;
                            case 5:
                                this.exceptions.friday.dates.push({
                                    date: fullDate,
                                    dateF: deleteDate,
                                    id: day.id,
                                    work_from: day.work_from,
                                    work_to: day.work_to,
                                });
                                this.exceptions.friday.highlighted.push(fullDate);
                                break;
                            case 6:
                                this.exceptions.saturday.dates.push({
                                    date: fullDate,
                                    dateF: deleteDate,
                                    id: day.id,
                                    work_from: day.work_from,
                                    work_to: day.work_to,
                                });
                                this.exceptions.saturday.highlighted.push(fullDate);
                                break;
                        }
                    }
                }.bind(this)
            );
        },

        delete_exception_day(id, dates = false) {
            let data = {};
            if (dates) {
                data.dates = dates;
            } else {
                data.id = id;
            }

            if (this.for_stylist_id != auth.state.user.id) {
                data.group_user_id = this.for_stylist_id;
            }
            this.$http.post(api.actions.delete_exception_day, data).then(
                function (response) {
                    if (response.data.error == false && id) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                        this.getExceptions();
                    }
                }.bind(this)
            );
        },

        disableDates(day) {
            const allowedDayMap = {
                monday: 1,
                tuesday: 2,
                wednesday: 3,
                thursday: 4,
                friday: 5,
                saturday: 6,
                sunday: 0,
            };

            const allowedDay = allowedDayMap[day];

            return (date) => {
                // disable past dates
                if (date < new Date().setHours(0, 0, 0, 0)) {
                    return true;
                }

                // disable all days except the allowed one
                return date.getDay() !== allowedDay;
            };
        },

        openTimeModal(date) {
            this.timeObj.date = moment.utc(date.date).format("YYYY-MM-DD");
            this.timeObj.work_from = this.processHourFormat(date.work_from);
            this.timeObj.work_to = this.processHourFormat(date.work_to);

            const closeModalEl = document.getElementById('time-modal');
            const closeModalInstance = Modal.getInstance(closeModalEl) || new Modal(closeModalEl);
            closeModalInstance.show();
        },
        changeTime() {
            let data = {};
            data.dates = {
                0: {
                    work_from: this.getProcessedHour(this.timeObj.work_from),
                    date: moment.utc(this.timeObj.date).format("YYYY-MM-DD"),
                    work_to: this.getProcessedHour(this.timeObj.work_to),
                },
            };
            if (this.for_stylist_id != auth.state.user.id) {
                data.group_user_id = this.for_stylist_id;
            }
            this.$http.post(api.actions.save_exception_days, data).then(
                function (response) {
                    if (response.data.error == false) {
                        messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_SAVE);
                        this.getExceptions();
                        eventBus.emit("reload_user_details");

                        this.closeTimeModal();
                    }
                }.bind(this)
            );
        },

        handleTimeSave(event, day, type) {
            const key = day + "_" + type;

            // HANDLE CLEAR (click on X)
            if (!event || event.hh === "" || event.mm === "") {
                if (!this.work_settings[key]) return; // already empty → skip

                this.work_settings[key] = null; // or "" if your API expects string
                this.saveWorkSettings();
                return;
            }

            // NORMAL CASE (time selected)
            const newTime = event.hh + ":" + event.mm + " " + event.A;

            if (this.work_settings[key] === newTime) return;

            this.work_settings[key] = newTime;
            this.saveWorkSettings();
        },
        closeTimeModal() {
            const closeModalEl = document.getElementById('time-modal');
            const closeModalInstance = Modal.getInstance(closeModalEl) || new Modal(closeModalEl);
            closeModalInstance.hide();
        }
    },
    components: {
        TimePicker,
        VueDatePicker,
        MainLoader,
    },
};
</script>
<style>
.fa-clock-o {
    position: absolute;
    top: -6px;
    font-size: 17px;
    left: -4px;
    cursor: pointer;
}

#time-modal .modal-body {
    min-height: 190px;
}

.time-save {
    position: absolute;
    bottom: 0;
    right: 15px;
}
</style>
